import React, { useState, useEffect } from "react";
import { ButtonContainer, TitleRow } from "./customerSettings.styled";
import { H3, Text } from "components/Typography/text.styled";
import { useTranslation } from "react-i18next";
import { ButtonStyled } from "components/buttons/buttons.styled";
import Table from "@material-ui/core/Table";
import {
  IconButton,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { FindInPage } from "@material-ui/icons";
import { FontFamily } from "config/font";
import { Color } from "config/colors";
import { AddCustomerForm } from "./addCustomerForm.component";
import { Api } from "services/api/api.service";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";
import { CompanyCustomer } from "model/Company";
import { CustomerModal } from "./customerModal.component";
import { CustomerInvoiceModal } from "./customerInvoiceModal.component";

type Props = {
  view?: string;
};
export const CustomerSettings: React.FC<Props> = ({ view }) => {
  const { t } = useTranslation();
  const [openRows, setOpenRows] = React.useState<{ [key: string]: boolean }>(
    {},
  );
  const [showAddCustomerForm, setShowAddCustomerForm] = useState(false);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [showCustomerInvoiceModal, setShowCustomerInvoiceModal] =
    useState(false);

  const [companyState] = useCompanyStore();
  const [selectedCustomer, setSelectedCustomer] = useState<CompanyCustomer>();

  const toggleRow = (id: any) => {
    setOpenRows((prev) => ({ ...prev, [id]: !prev[id] }));
  };
  const [customers, setCustomers] = useState<any[]>([]);
  const onSaveCustomer = (customer: CompanyCustomer) => {
    console.log(customer);

    let companyId = companyState.company?.id;
    if (companyId) {
      Api()
        .company.addCompanyCustomer(companyId, customer)
        .then((result: any) => {
          let storedCustomer: CompanyCustomer = result.data;
          if (customers) {
            setCustomers([...customers, storedCustomer]);
          }
        })
        .catch((err) => console.error(err));
    }
  };

  useEffect(() => {
    let companyId = companyState.company?.id;
    if (companyId) {
      Api()
        .company.getCompanyCustomers(companyId)
        .then((result) => {
          setCustomers(result.data);
        })
        .catch((err) => console.error(err));
    }
  }, []);

  return (
    <>
      <TitleRow>
        <H3>{t("CompanyCustomers.Customers")}</H3>
        <ButtonContainer>
          <ButtonStyled onClick={() => setShowAddCustomerForm(true)}>
            {t("CompanyCustomers.AddCustomer")}
          </ButtonStyled>
        </ButtonContainer>
      </TitleRow>

      {customers.length > 0 && (
        <TableContainer>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {/* <TableCell></TableCell> */}
                <TableCell style={{ fontFamily: FontFamily.MontserratRegular }}>
                  {t("CompanyCustomers.Customer")}
                </TableCell>
                <TableCell style={{ fontFamily: FontFamily.MontserratRegular }}>
                  {t("CompanyCustomers.OrganizationNumber")}
                </TableCell>
                <TableCell style={{ fontFamily: FontFamily.MontserratRegular }}>
                  {t("CompanyCustomers.Contact")}
                </TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customers.map((customer: CompanyCustomer) => (
                <React.Fragment key={customer.organizationNumber}>
                  <TableRow>
                    <TableCell
                      style={{ fontFamily: FontFamily.MontserratRegular }}
                    >
                      {customer.name}
                    </TableCell>
                    <TableCell
                      style={{ fontFamily: FontFamily.MontserratRegular }}
                    >
                      {customer.organizationNumber}
                    </TableCell>
                    <TableCell
                      style={{ fontFamily: FontFamily.MontserratRegular }}
                    >
                      {customer.contact}
                    </TableCell>
                    <TableCell>
                      <Text
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSelectedCustomer(customer);
                          setShowCustomerInvoiceModal(true);
                        }}
                        color={Color.BurntSienna}
                      >
                        {t("CompanyCustomers.CreateInvoice")}
                      </Text>
                    </TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setSelectedCustomer(customer);
                          setShowCustomerModal(true);
                        }}
                      >
                        <FindInPage />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <AddCustomerForm
        setShowAddCustomerForm={setShowAddCustomerForm}
        showAddCustomerForm={showAddCustomerForm}
        saveCustomer={(customer) => onSaveCustomer(customer)}
      />

      <CustomerModal
        setShowCustomerModal={setShowCustomerModal}
        showCustomerModal={showCustomerModal}
        customer={selectedCustomer}
        setCustomers={(customers: CompanyCustomer[]) => setCustomers(customers)}
      />
      <CustomerInvoiceModal
        setShowCustomerInvoiceModal={setShowCustomerInvoiceModal}
        showCustomerInvoiceModal={showCustomerInvoiceModal}
        customer={selectedCustomer}
        companyId={companyState.company?.id}
      />
    </>
  );
};
